<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">ACCRUED CASH ADVANCE 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <!-- <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button> -->
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i>Filter</button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
          <b-col xl="5">
            <b-input-group >
                <b-input-group-prepend><label>Accrued Periode</label></b-input-group-prepend>
                <vue-monthly-picker v-model="tblData.tanggal" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangePeriode"></vue-monthly-picker>
            </b-input-group>
          </b-col>
      </b-row>      
      <b-row v-if="showFilter">
        <b-col lg="6" xl="5">
            <b-input-group >
                <b-input-group-prepend><label>Adv.Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col xl="6">
            <b-input-group >
              <b-input-group-prepend><label>Adv.Request No.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder="Request Number"></b-form-input>
                <b-input-group-prepend><span class="p-2"> Group</span></b-input-group-prepend>
                <b-form-select v-model="tblData.jenisAdv" :plain="true" :options="postGroups"></b-form-select>
              <b-input-group-prepend><span class="p-2">Reversed</span></b-input-group-prepend>
              <b-form-select v-model="tblData.reversed" :plain="true" :options="YesNoAll"></b-form-select>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Debit/Accrued Acc.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
              <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
              <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group>
        </b-col>
        <!-- <b-col >
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
        </b-col> -->
      </b-row>
      <b-table
        class="mb-0"
        ref="tblAccuredJv"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(advAcc)="data">
          {{data.item.advAcc}} <span v-if="(data.item.postgrpname)">| {{data.item.postgrpname}}</span>
        </template>
        <template v-slot:cell(tglPaym)="data">
          {{data.item.tglPaym| moment("DD MMM YYYY")}}
        </template>
        <template v-slot:cell(nilaiPaym)="data">
          {{data.item.nilaiPaym | numFormat}}
        </template>
        <template v-slot:cell(umasuk)="data">
          <div v-if="data.item.reversed==0" style="background-color:yellow;">           
              {{data.item.umasuk | numFormat}}
          </div>
          <div v-else> {{data.item.umasuk | numFormat}} </div>
        </template>
        <template v-slot:cell(tglAccrue)="data">
          {{data.item.tglAccrue| moment("DD MMM YYYY")}}
        </template>
        <template v-slot:cell(kodeacc)="data">
          {{data.item.kodeacc}} | {{data.item.namaacc}}
        </template>
        <template v-slot:cell(reversdate)="data">
          {{data.item.reversdate| moment("DD MMM YYYY")}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit2" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit2} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Accrued Not REVERSED yet</span>
          </div>
        </b-col>
      </b-row>

    </b-card>
    
    <b-card v-if="showForm">
      <div slot="header">Accrued Process Form 
        <div class="card-header-actions">
          <div style="width:530px; !important; ">
            <b-input-group >
              <b-input-group-prepend><span class="p-2">Accured Date:</span></b-input-group-prepend>
              <b-form-input v-model="tblTemp.tglAccrue" type="date"  @change="tanggalBerubah"></b-form-input>
              <b-input-group-append>
                  <button class="btn btn-primary mr-1" @click="save()" v-if="saveEnabled"> <i class="fa fa-save"></i> Save </button>
              </b-input-group-append>
              <b-input-group-append>
                  <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
              </b-input-group-append>

            </b-input-group>
          </div>  
        </div>
      </div>
            <b-row v-if="(filterShow=='Hide')">
              <b-col lg="5">
                  <b-input-group size="sm" class="ml-1">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
              <b-col lg="7">
                  <b-input-group size="sm" >
                      <b-input-group-prepend > <span class="p-1">Filter On:</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                          <b-form-checkbox value="uraian">Description</b-form-checkbox>
                          <b-form-checkbox value="vendorinfo">Vendor/Supplier</b-form-checkbox>
                          <b-form-checkbox value="db_kodeacc">DB Account#</b-form-checkbox>
                          <b-form-checkbox value="db_namaacc">DB Account Name</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>

  <!-- Gunakan properti sticky-header pada b-table untuk membuat judul kolom tidak ikut bergerak saat di scroll          
  sticky-header="600px" -->
        <b-table
          class="mb-0"
          ref="tableOri"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="accrutmps"
          :fields="accrutmpFields"
          :current-page="tblTemp.page"
          :per-page="tblTemp.limit"
          :sort-by.sync="tblTemp.sortBy"
          :sort-desc.sync="tblTemp.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(terpilih)="data">
              <b-form-checkbox
                v-model="data.item.terpilih"
                style="width:20px;"
                value=1 unchecked-value=0 @change="calcTotalAccruedFrm(data.item, data.index)"
              ></b-form-checkbox>
          </template>
        <template v-slot:cell(tglPaym)="data">
          {{data.item.tglPaym| moment("DD MMM YYYY")}}
        </template>
          <template v-slot:cell(nilaiPaym)="data">
            {{ data.item.nilaiPaym | numFormat }}
          </template>
          <template v-slot:cell(nilaiPJ)="data">
            {{ data.item.nilaiPJ | numFormat }}
          </template>
          <template v-slot:cell(umasuk)="data">
                <b-input-group size="sm" >
                  <my-number separator="," v-model="data.item.umasuk"   :precision="2" class="form-control small text-right"></my-number>
                </b-input-group>
          </template>
          <template v-slot:cell(dbAccount)="data">
                <b-input-group size="sm" >
                    <b-form-input v-model="data.item.kodeacc" @change="cekKodeacc(data.item)"></b-form-input>
                    <b-form-input readonly v-model="data.item.namaacc" @keyup.13.native="showLkuCoa(data.index)" style="width:50% !important;"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="showLkuCoa(data.index)" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="5">
            <b-input-group class="mr-2">
                <b-input-group-prepend><span class="p-2">Total Data Accrued</span></b-input-group-prepend>
                  <!-- <my-number v-model="totalRecord" readonly class="form-control text-right"  separator="," ></my-number> -->
                <b-input-group-prepend><span class="input-group-text">{{totalRecord | numFormat}} records</span></b-input-group-prepend>
                <b-input-group-prepend><span class="p-2">&nbsp;&nbsp;&nbsp; Total Amount Accrued</span></b-input-group-prepend>
                <b-input-group-prepend><span class="input-group-text">{{ uanguser }}</span></b-input-group-prepend>
                  <my-number v-model="totalAmount" readonly class="form-control text-right" :precision="2"  separator="," style="width:28% !important;" ></my-number>
            </b-input-group>
          </b-col>
          <b-col cols="7">
            <b-row>
              <b-col cols="6" style="text-align: center">
                <div>
                  Showing {{ (tblTemp.page - 1) * tblTemp.limit + 1 }} to
                  <span v-if="tblTemp.page * tblTemp.limit > tblTemp.total">{{
                    tblTemp.total
                  }}</span>
                  <span v-else>{{ tblTemp.page * tblTemp.limit }}</span> of
                  {{ tblTemp.total }} entries
                </div>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                    <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                    <b-form-input v-model="limit" type="number" class="mr-2"></b-form-input>  
                    <b-pagination
                      align="right"
                      :total-rows="tblTemp.total"
                      :per-page="tblTemp.limit"
                      v-model="tblTemp.page"
                    ></b-pagination>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

    </b-card>

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMonthlyPicker from 'vue-monthly-picker';
import myNumber from "../../components/my-number";
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import moment from 'moment';
import accrued from "../../apis/advaccrued";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        advPayKey: { required },
        kodeacc: { required },
        umasuk: { required, minValue:minValue(1) },
    },
  }, 
  data() {
    return {
      saveEnabled:true,
      showDelConfirm: false,
      horizontal: true,
      isLoading:false,
      showList:true,
      showForm:false,
      showEdit:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      lkuVendorShow:false,
      showReport:false,
      reportUrl: null,
      uanguser: this.$store.state.user.matauang,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      monthLabels:dropdown.monthLabels,
      accrutmps:[],
      postGroups:[],
      model:{},
      frmdata:{accrujvkey:'',accrutmpkey:'', jmlaccru:1},
      limit2:15,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        periode: moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
      },
      filterShow: "Show",
      filter: null,
      filterOn: [],
      tblTemp: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "db_kodeacc",
        sortDesc: false,
        tglAccrue: this.$store.state.user.akhirbln        
      },
      limit:20,
      totalRecord:0, totalAmount:0,
      coa:[],
      YesNoAll: dropdown.YesNoAll,
    };
  },
  components: {Loading, VueMonthlyPicker,myNumber, lkuCoa},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Advance Number",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "advAcc",
            label: "Advance Account",
            sortable: true
          },
          {
            key: "tglPaym",
            thStyle: "width:90px",
            label: "Payment Date",
            sortable: true
          },
          {
            key: "nomorPaym",
            thStyle: "width:100px",
            label: "Payment Number",
            sortable: true
          },
          {
            key: "nilaiPaym",
            label: "Payment Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "umasuk",
            label: "Accrued Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "tglAccrue",
            thStyle: "width:90px",
            label: "Accrued Date",
            sortable: true
          },
          {
            key: "nomorjv",
            label: "Accrued JV",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "Accrued (DB) Account#",
            sortable: true
          },
          {
            key: "reversdate",
            label: "Reverse Date",
            thStyle: "width:90px",
            thClass:"text-center",
            tdClass:"text-center",
            sortable: true
          },
          {
            key: "reversedjv",
            label: "Reverse JV",
            thClass:"text-center",
            tdClass:"text-center",
            sortable: true
          },

        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },
    accrutmpFields(){
      const fields=[
          {
            key: "nomor",
            label: "Adv.Request#",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "tglPaym",
            thStyle: "width:90px",
            label: "Payment Date",
            sortable: true
          },
          {
            key: "nomorPaym",
            thStyle: "width:100px",
            label: "Payment Number",
            sortable: true
          },
          {
            key: "nilaiPaym",
            label: "Payment Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaiPJ",
            label: "Advance/PJ Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "terpilih",
            label: "",
            thStyle: "width:10px",
            thClass: "text-center",
          },
          {
            key: "umasuk",
            label: "Accrued Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "dbAccount",
            label: "DB Account#",
            thStyle: "width:300px",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}info`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },

    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblTemp.limit=newVal;
        }
      }, 500);
    },    
    limit2: function (newVal){
      setTimeout(() => {
        if (this.limit2==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  created: async function () {
        const [a,b] = await Promise.all([accrued.advancegroup(), accrued.getcoa({ tahun: this.tahun})]);
        this.postGroups = a;
        this.postGroups.unshift({value:'',text:'All'});
        this.tblData.tanggal = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
        this.tblData.periode = this.tblData.tanggal.endOf('month').format('YYYY-MM-DD');
        this.coa = b;
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    onChangePeriode() {
      if (this.tblData.tanggal){
          this.tblData.periode = this.tblData.tanggal.endOf('month').format('YYYY-MM-DD');
          this.refresh();
      }
    },
    onChangeJmlAccru (row) {
      row.booked = (row.booked || 0);
      row.total = parseFloat(row.nilai || 0) * row.jmlaccru;
      row.totalwill = row.booked + row.total;
      this.$forceUpdate();
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

        try {
            this.isLoading=true;
            const list = await accrued.trxlist(this.tblData);      
            this.items = list;
            this.isLoading=false;
          return list;
        } catch (error) {
            this.isLoading=false;
          console.log(error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
        }      
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh(ctx) {
      if (this.$refs.tblAccuredJv)  this.$refs.tblAccuredJv.refresh();
    },
    clearFilter(ctx) {
      this.tblData.tanggal='';
        this.tblData.periode= '';
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.DimVal=  '';
        this.tblData.nomor='';
        this.tblData.jenisAdv='';
        this.tblData.reversed='';
        this.$forceUpdate();
        // this.refresh();
    },
    add: async function() {
        try {
            this.isLoading=true;
            this.accrutmps= await accrued.trxnotaccrued(this.tblData);
            this.tblTemp.total=this.accrutmps.length;
            this.showForm=true;
            this.showList=false;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
          console.log(error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
        }      

    },
    calcTotalAccruedFrm: function(record,index){
      if (!(record.umasuk)) {
          record.umasuk=record.nilaiPJ;
      }
      setTimeout(() => {
          this.totalRecord= this.accrutmps.filter(a => a.terpilih == 1).length;
          this.totalAmount= this.accrutmps.filter(a => a.terpilih == 1).reduce(
                (a, b) => a + b.umasuk,0);
      }, 500);
    },
    cekKodeacc: function(record) {

          console.log('cekKodeacc after 100tm: ',record.kodeacc);
          const kodeacc = (record.kodeacc || '').trim();
          if (kodeacc) {
            const _selected = this.coa.find(p => p.kodeacc==kodeacc);
            if (_selected) {
                // console.log(' coa diketik : ', _selected);
                record.dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                record.kodeacc = _selected.kodeacc;
                record.namaacc = _selected.namaacc;
                this.$forceUpdate();  
            } else {
                record.kodeacc='';
                record.namaacc = '';
            }
          } else {
                record.kodeacc='';
                record.namaacc = '';
          }
        
    },
    tanggalBerubah: function(){
        const newVal=moment(this.model.sttlDate).format('YYYY');
        if ( this.tahun != newVal) {
            this.tahun=newVal;
            accrued.getcoa({ tahun: this.tahun}).then(result => {
                    this.coa = result;
                        if  (this.coa.length==0) {
                            this.getCoa();
                        }                        
                    })
                    .catch(err => {
                        console.log('get COA -> ', err);
                    });
            } else if  (this.coa.length==0) {
                this.getCoa();
            }
    },
    getCoa: function(){
        this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
        accrued.getcoa({ tahun: this.tahun}).then(result => {
                this.coa = result;
            })
            .catch(err => {
                console.log('get COA -> ', err);
            });
    },      

    // edit: function(data) {
    //     if (this.model.advAccruKey) {
    //         for (var key in this.frmdata) {
    //             this.frmdata[key] = '';
    //         }
    //         for (var key in this.model) {
    //             this.frmdata[key] = this.model[key];
    //         }
    //         this.frmdata.tglPaym = this.model.tglAccrue ? moment(this.model.tglAccrue).format('YYYY-MM-DD') : '';
    //         this.frmdata.dbAccount = this.model.kodeacc.trim() + ' | ' + this.model.db_namaacc.trim();
    //         this.showEdit=true;
    //         this.showList=false;
    //     } else {
    //         toastr.warn('Please select a row that want to be Edit!');
    //     }
    // },
    // deleteConfirm() {
    //     if (this.model.advAccruKey) {
    //       this.showDelConfirm = true;
    //     } else {
    //         toastr.warn('Please select a row that want to be Delete!');
    //     }
    // },
    // deleteData: async function() {
    //   await accrued.trxremove(this.model);
    //   this.refresh();
    // },

    save: async function () {
        if (!this.saveEnabled) {
            return;
        }
        this.isLoading=true;

        try {
          // const data = { tanggal : moment(this.tblTemp.tglAccrue).endOf('month').format('YYYY-MM-DD') };
          const data = { tanggal : moment(this.tblTemp.tglAccrue).format('YYYY-MM-DD') };
          const terpilih = this.accrutmps.filter(a => (a.terpilih));
          // console.log('terpilih : ', terpilih);
          if (terpilih.length>0) {
            const diisi = terpilih.filter(a => (a.umasuk));
          //  console.log('Amount diisi : ', diisi);
            if (terpilih.length == diisi.length) {
                const lengkap = diisi.filter(a => (a.kodeacc));
                //  console.log('kodeacc diisi : ', lengkap);
                if (lengkap.length == diisi.length) {
                    data.lines = lengkap.map(function(rw) {
                        return {
                            advPayKey: rw.advPayKey, umasuk: rw.umasuk, kodeacc:rw.kodeacc, uraian: rw.uraian || rw.keterangan , DimTableKey: rw.DimTableKey                   
                        };
                    });   
                    try {
                        const hasil = await accrued.trxsave(data);
                        toastr.success(`Success, Trx.Number ${hasil.nomorjv}`, "Accrued Cash Advance",10000);
                        this.closeFrm();              
                        setTimeout(() => {
                            this.refresh();              
                        }, 500);       
                        this.isLoading=false;
                    } catch (error) {
                        console.log('error : ', error);
                        if (error.sql) {
                            toastr.error(error.sql,'ERROR MESSAGE',10000);
                        } else if (error.sqlMessage) {
                            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                        } else if (error.message) {
                            toastr.error(error.message,'ERROR MESSAGE',10000);
                        } else {
                            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                        }   
                        this.isLoading=false;            
                    }


                } else {
                  toastr.error(`Please fill the form correctly. Accrued [DB Account#] can't be emptied`, "ERROR MESSAGE",10000);
                  this.isLoading=false;            
                }
            } else {
                  console.log(diisi);
                  toastr.error(`Please fill the form correctly. [Accrued Amount] can't be emptied`, "ERROR MESSAGE",10000);
                  this.isLoading=false;            
            }
          } else {
                  toastr.error('No Records selected to be saved', "ERROR MESSAGE",10000);
                  this.isLoading=false;            

          }
        } catch (error) {
          console.log(error);
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }              
          this.isLoading=false;            
        }
    },    
    // saveEdit: function () {
    //     if (!this.saveEnabled) {
    //         return;
    //     }
    //     this.saveEnabled=false;            
    //     if (this.invalidFormdata) {
    //           toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
    //           this.saveEnabled=true;            
    //     } else {
    //         try {
    //           let data={};
    //           data.tglAccrue = this.tblData.tanggal.endOf('month').format('YYYY-MM-DD') ;
    //           data.advAccruKey = this.frmdata.advAccruKey;
    //           data.advPayKey = this.frmdata.advPayKey;
    //           data.kodeacc = this.frmdata.kodeacc;
    //           data.uraian = this.frmdata.uraian;
    //           data.umasuk = this.frmdata.umasuk;
    //           accrued.trxupdate(data);
    //           setTimeout(() => {
    //               this.refresh();              
    //           }, 500);       
    //           this.closeFrm();       
    //         } catch (error) {
    //           this.saveEnabled=true;            
    //           console.log(error);
    //             if (error.message) {
    //                 toastr.error(error.message);
    //             } else {
    //                 toastr.error(JSON.stringify(error));
    //             }              
    //         }
    //     }
    // },    
    printjv: async function()
    {
       if (this.model.advanKey) {
          try {
              this.reportUrl= await accrued.printjv({ nomor: this.model.nomorjv, tanggal:moment(this.model.tglAccrue).format('YYYY-MM-DD'), kodejurnal: 'ADVACCRU'});
              this.showReport=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            const response = await accrued.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },  
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(index)
    {
      this.accrutmpIndex=index;
      if ((index===0) || (index)) {
         this.selectedObj=this.accrutmps[this.accrutmpIndex]
      } else {
          this.selectedObj=this.formdata;
      } 

      this.lkuCoaShow=true;
    },
    onSelectLkuCoa(_selected) {
            // this.accrutmps[this.accrutmpIndex].dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            // this.accrutmps[this.accrutmpIndex].kodeacc = _selected.kodeacc;
            // this.accrutmps[this.accrutmpIndex].db_namaacc = _selected.namaacc;
            this.selectedObj.dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.selectedObj.kodeacc = _selected.kodeacc;
            this.selectedObj.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuVendor(_selected) {
        this.frmdata.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.frmdata.vendor = _selected.vendor_code;
        this.lkuVendorShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showEdit=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
